import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { apiUrl } from '../../utils/url';
import { toast } from 'react-toastify';
import { hideLoader, showLoader } from '../loader';

const AddVariableInput = () => {
    const { slug } = useSelector(state => state?.slugReducer);
    const [newVariable, setNewVariable] = useState();
    const dispatch = useDispatch();
    const variables = useSelector(state => state?.variablesReducer);
    const predefinedVariables = new Set(['company_name', 'lead_first_name', 'email', 'ignore']);
    const handleAddVariable = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        // Append the new variable to your array
        if (newVariable && newVariable?.trim() && !variables.includes(newVariable)) {
            showLoader();
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
            var formdata = new FormData();
            formdata.append("project", slug)
            formdata.append("new_variable", newVariable)
            const api = apiUrl + '/project/add-variable';
            const setOptions = {
                headers: myHeaders,
                body: formdata,
                method: 'POST'
            }
            fetch(api, setOptions).then(async (res) => {
                const response = await res.json();
                if (response?.status_code == 200) {
                    dispatch({ type: "SET_VARIABLES", payload: [...variables, newVariable] })
                    setNewVariable('');
                    toast.success(response?.status_message);
                    hideLoader();
                } else {
                    //   setError(Object.values(response?.errors));
                    toast?.error(response?.status_message)
                    hideLoader();
                }
            }).catch((error) => {
                toast?.error(error)
                hideLoader()

            })
        } else {
            toast.error("Please add a valid variable");
        }
    });
    return (
        <div className="add-new-variable-inp d-flex align-items-center zaapGlobal-input ps-2 p-0">
            <input
                type="text"
                value={newVariable}
                onChange={(e) => setNewVariable(e.target.value)}
                placeholder="Add new variable"
            />
            <button type="button" className="variable-dropdown" onClick={handleAddVariable}>
                Add
            </button>
        </div>
    )
}

export default AddVariableInput